import React from 'react'
import {QueryGetEmpreendimentoSituacao} from '../../../../../graphql/services/EmpreendimentoSituacao'
import {QueryGetEmpreendimentosRelatorioStatusUsuario} from '../../../../../graphql'
import {BarChart} from './BarChart'

type Props = {
  className: string
}

const TablePorSituacaoEmpreendimentoUsuario: React.FC<Props> = ({className}) => {
  const {data: dataStatus} = QueryGetEmpreendimentoSituacao({
    variables: {
      pagination: {
        pagina: 0,
        quantidade: 100,
      },
    },
  })

  const {data: dataRelatorio} = QueryGetEmpreendimentosRelatorioStatusUsuario({
    variables: {
      pagination: {
        pagina: 0,
        quantidade: 100,
      },
    },
  })

  if (!dataStatus || !dataRelatorio) {
    return <div>Carregando...</div>
  }

  const situacoes = dataStatus.GetEmpreendimentoSituacao.result
  const usuariosPorId = new Map<
    number,
    {id: number; nome: string; quantidades: Map<number, number>}
  >()

  dataRelatorio.GetEmpreendimentosRelatorioStatusEmpreendimentoUsuario.forEach((item) => {
    let usuario = usuariosPorId.get(item.id)

    if (!usuario) {
      usuario = {id: item.id, nome: item.usuario, quantidades: new Map()}
      usuariosPorId.set(item.id, usuario)
    }

    usuario.quantidades.set(
      item.id_status,
      (usuario.quantidades.get(item.id_status) ?? 0) + item.qtde
    )
  })

  const usuarios = Array.from(usuariosPorId.values())
  const dataReport = situacoes.map((situacao) => ({
    name: situacao.nome,
    data: usuarios.map((usuario) => usuario.quantidades.get(situacao.id) ?? 0),
  }))

  return (
    <div className={`card ${className}`}>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Empreendimentos</span>
          <span className='text-muted mt-1 fw-semibold fs-7'>Usuário x Situação</span>
        </h3>
      </div>
      <div className='card-body py-3'>
        <BarChart
          className={''}
          title={''}
          subtitle={''}
          legenda={['']}
          data={dataReport}
          onChange={() => {}}
          categorias={usuarios.map((usuario) => usuario.nome)}
          series={dataReport}
        />

        <div className='table-responsive'>
          <table className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4'>
            <thead>
              <tr className='border-0'>
                <th className='p-0'>Usuário</th>
                {situacoes.map((situacao) => (
                  <th key={situacao.id} className='p-0 text-center'>
                    {situacao.nome}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {usuarios.map((usuario) => (
                <tr key={usuario.id}>
                  <td>
                    <span className='text-dark fw-bold mb-1 fs-6'>
                      {usuario.nome}
                    </span>
                  </td>
                  {situacoes.map((situacao) => (
                    <td key={situacao.id} className='text-center text-muted fw-semibold'>
                      {usuario.quantidades.get(situacao.id) ?? 0}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export {TablePorSituacaoEmpreendimentoUsuario}
